export const SET_DATA = 'mp/omni/omnisales/SET_DATA';
export const OMNI_GET_COMMUNITY = 'mp/omni/omnisales/OMNI_GET_COMMUNITY';
export const OMNI_LOCALIZE = 'mp/omni/omnisales/OMNI_LOCALIZE';
export const GET_SUGGESTIONS = 'mp/omni/omnisales/GET_SUGGESTIONS';
export const SELECT_SUGGESTION = 'mp/omni/omnisales/SELECT_SUGGESTION';

const initialState = {};

const omniSales = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export const omniGetCommunity = () => {
  return {
    type: OMNI_GET_COMMUNITY
  };
};

export const omniLocalizeAddress = () => {
  return {
    type: OMNI_LOCALIZE
  };
};

export const getSuggestions = (search) => {
  return {
    type: GET_SUGGESTIONS,
    payload: {
      search
    }
  };
};

export const selectSuggestion = suggestion => {
  return {
    type: SELECT_SUGGESTION,
    payload: {
      suggestion
    }
  };
};

export default omniSales;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Omni/omniSales/localization.js
 **/